import * as React from 'react';
export const bawagSvg = React.forwardRef(function bawagSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#900',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'm14.55 32 8.72-16-8.72-16v32zm-1.46 0V13.1l-5.82 9.18L13.13 32h-.04z',
      }),
    ),
  );
});
bawagSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var bawag = {
  category: 'brand',
  colorable: false,
  name: 'bawag',
  svg: bawagSvg,
};
